import { storyblokEditable } from "@storyblok/react";
import ListItem from "./ListItem";

const BrandsImgText = ({ blok }) => (
  <div className="wrap">
    <div
      className="brandsimgtext-wrap inner-wrap items-center flex"
      {...storyblokEditable(blok)}
    >
      <div className="brandsimgtext-content">
        <img
          className="hide-desktop"
          src={blok.image.filename}
          alt={blok.image.alt}
        />
      </div>
      <div className="brandsimgtext-right ml-16">
        <h2 className="text-2xl">{blok.subheadline}</h2>
        <img
          className="brandsimgtext-mobile hide-mobile"
          src={blok.image.filename}
          alt={blok.image.alt}
        />

         {blok.infotext && (<p className="pb-3">{blok.infotext}</p>)} 
         {blok.infotext2 && (<p className="pb-3">{blok.infotext2}</p>)} 
         {blok.infotext3 && (<p className="pb-3">{blok.infotext3}</p>)} 
         {blok.infotext4 && (<p className="pb-3">{blok.infotext4}</p>)} 
         {blok.infotext5 && (<p className="pb-3">{blok.infotext5}</p>)} 

        <ul>
          <ListItem blok={blok} />
        </ul>
      </div>
    </div>
  </div>
);
export default BrandsImgText;
